import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { showTemporaryMessage } from "../components/Message";
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../components/AuthProvider';
import { LayoutContext } from '../components/LayoutProvider';

import PickUser from '../components/PickUser';
import PickBearer from '../components/PickBearer';

import RegisterQrCodeStep1 from '../components/RegisterQrCodeStep1';
import RegisterQrCodeStep2 from '../components/RegisterQrCodeStep2';
import RegisterQrCodeStep3 from '../components/RegisterQrCodeStep3';
import RegisterQrCodeStep3b from '../components/RegisterQrCodeStep3b';
import RegisterQrCodeStep4 from '../components/RegisterQrCodeStep4';

import {
	update_scan_token
} from "../tools-network";

/**
 This page has five subpages:
  - Step 1: Enter or verify user's phone number
  - Step 2: Create or select bearer
  - Step 3: Give wristband a name
  - Step 3b: Choose wristband color
  - Step 4: Encourage user to make a test scan of wristband
 */
const RegisterQrCode = () => {

	const { t } = useTranslation();

	const { userType, loginToken, userId } = React.useContext(AuthContext);
	const { setIsHeaderVisible, setIsFooterVisible } = React.useContext(LayoutContext);

	const [currentStep, setCurrentStep] = useState(1);
	const [selectedBearerId, setSelectedBearerId]	= useState(0);
	const [selectedBearerName, setSelectedBearerName] = useState('');
	const [suggestedWristbandName, setSuggestedWristbandName] = useState('');

	useEffect(() => {
		setIsHeaderVisible(false);
		setIsFooterVisible(false);

		return () => {
			setIsHeaderVisible(true);
			setIsFooterVisible(true);
		};
	}, [setIsHeaderVisible, setIsFooterVisible]);

	const renderStep = () => {
		switch(currentStep) {
			case 1:
				// Register phone number
				return (
					<RegisterQrCodeStep1
						onNext={() => setCurrentStep(2)}
					/>
				);
			case 2:
				// Select or create bearer
				return (
					<RegisterQrCodeStep2
						onNext={(bearerName) => {
							if (bearerName) {
								setSelectedBearerName(bearerName);
								// Use language-aware formatting
								const wristbandName = t('wristband_name_format', { name: bearerName });
								setSuggestedWristbandName(wristbandName);
							}
							setCurrentStep(3);
						}}
						onPrevious={() => setCurrentStep(1)}
						reportSelectedBearerId={setSelectedBearerId}
					/>
				);
			case 3:
				// Set name of wristband
				return (
					<RegisterQrCodeStep3
						selectedBearerId={selectedBearerId}
						suggestedName={suggestedWristbandName}
						onNext={() => {
							setSuggestedWristbandName('');
							setCurrentStep(4);
						}}
						onPrevious={() => {
							setSuggestedWristbandName('');
							setCurrentStep(2);
						}}
					/>
				);
			case 4:
				// Choose wristband color
				return (
					<RegisterQrCodeStep3b
						selectedBearerId={selectedBearerId}
						bearerName={selectedBearerName}
						onNext={() => setCurrentStep(5)}
						onPrevious={() => setCurrentStep(3)}
					/>
				);
			case 5:
				// Test scan the QR code
				return (
					<RegisterQrCodeStep4
						selectedBearerId={selectedBearerId}
						onPrevious={() => setCurrentStep(4)}
					/>
				);
			default:
				return null;
		}
	};

	return (<>
			{userType == 'PRINTER' &&
				<div>You are a PRINTER user and not allowed to administer bearers!</div>}
			{userType == 'SUPERUSER' &&
				<div>You are a SUPERUSER user and not allowed to administer bearers!</div>}
			{ (userType == 'REGULAR' || userType == 'ADMIN') &&
				<div className="w-full justify-center items-center">{renderStep()}</div>}
			</>);
};

export default RegisterQrCode;

